<msi-modal>
	<msi-modal-header>
		@if (data.headerIcon) {
			<msi-icon [name]="data.headerIcon" [size]="20"></msi-icon>
		}
		{{ data.title }}
	</msi-modal-header>
	<msi-modal-content>
		<p class="content-text">{{ data.message }}</p>
		@if (data.message2) {
			<p class="content-text msi-margin-top-m">{{ data.message2 }}</p>
		}
		@if (data.showCheckbox) {
			<msi-checkbox i18n id="dontAskAgainCheckbox" class="msi-checkbox" [(ngModel)]="dontAskAgain" ngDefaultControl>
				Don't ask again
			</msi-checkbox>
		}
		@if (data.showTextInput) {
			<label class="input-label" for="rename">
				{{ data.textInputLabel }}
			</label>
			<div class="renameInput" (keydown.enter)="confirm()">
				<div class="input-field-container">
					<input
						class="msi-input"
						id="renameNode"
						autocomplete="off"
						placeholder="{{ data.friendlyName }}"
						[(ngModel)]="userInput"
						(ngModelChange)="validateInput()"
						ngDefaultControl
						#input
						(keydown)="$event.stopPropagation()"
						(keydown.enter)="!confirmDisabled && confirm()" />
				</div>
				@if (data.originalName) {
					<button id="resetInputButton" class="msi-btn msi-btn-icon" (click)="resetName()">
						<msi-icon [name]="'ic_refresh'" [size]="18"></msi-icon>
					</button>
				}
			</div>
		}
		<b class="input-error-message"> {{ inputErrorMessage }}</b>
	</msi-modal-content>
	<msi-modal-actions>
		<div class="msi-flex-row justify-content-between w-100">
			<div class="msi-flex-row">
				@if (actionButtonText) {
					<button id="modalActionButton" class="msi-btn msi-btn-action modal-btn" (click)="actionButton()">
						{{ actionButtonText }}
					</button>
				}
			</div>
			<div class="msi-flex-row">
				@if (!data.hideCancelButton) {
					<button id="modalCancelButton" class="msi-btn msi-btn-secondary modal-btn" (click)="cancel()">
						{{ cancelButtonText }}
					</button>
				}
				<button id="modalConfirmButton" class="msi-btn modal-btn" (click)="confirm()" [disabled]="confirmDisabled">
					{{ confirmText }}
				</button>
			</div>
		</div>
	</msi-modal-actions>
</msi-modal>

<!-- Copyright (c) Motorola Solutions Inc. All Rights Reserved. -->
